import React from 'react';
import { object, string, arrayOf, oneOf, number, func } from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import ListingItem from '../items/ListingItem';
import Resources from '../resources/';
import ItemPagination from './ItemPagination';
import NoItems from './NoItems';
import ProductsHeader from './ProductsHeader';
import isEcowise from './utils/isEcowise';

export default function ListingItemsSection({
    listingItems,
    resources,
    itemWrapperModifier,
    itemDirection,
    itemType,
    totalPages,
    currentPage,
    changePage,
    resetFilters,
    handleOpenModal,
    viewMoreText,
    meetUsText,
    downloadText,
    viewProductText,
    noItemsText,
    noDataMessage,
    noDataButtonText,
    noDataButtonUrl,
    columnName1,
    columnName2,
    columnName3
}) {
    let resultsWrapperClass = 'listing-items-wrapper';
    if (resources.length >= 1) {
        resultsWrapperClass += ' has-resources';
    }

    return (
        <div className="listing-items-section">
            <div className="listing-items-container">
                <div className={resultsWrapperClass}>
                    <div className="listing-items">
                        <NoItems
                            items={listingItems.length}
                            resetFilters={resetFilters}
                            noItemsText={noItemsText}
                            noDataMessage={noDataMessage}
                            noDataButtonText={noDataButtonText}
                            noDataButtonUrl={noDataButtonUrl}
                        />
                        <ProductsHeader
                            itemsLength={listingItems.length}
                            itemType={itemType}
                            columnName1={columnName1}
                            columnName2={columnName2}
                            columnName3={columnName3}
                        />
                        <TransitionGroup
                            className={`listing-item-container ${itemWrapperModifier}`}
                        >
                            {listingItems.map((item, index) => (
                                <CSSTransition
                                    /* eslint-disable react/no-array-index-key */
                                    appear
                                    classNames="fade-in-out"
                                    key={index}
                                    timeout={200}
                                >
                                    <ListingItem
                                        // @NOTE - ideally the key should be item.guid but this creates a jumpy effect with React transition group, so we will
                                        //         keep using index for now until we find a better solution
                                        item={item}
                                        itemDirection={itemDirection}
                                        itemType={itemType}
                                        handleOpenModal={handleOpenModal}
                                        ListingItemsSection={
                                            ListingItemsSection
                                        }
                                        viewMoreText={viewMoreText}
                                        meetUsText={meetUsText}
                                        downloadText={downloadText}
                                        viewProductText={viewProductText}
                                        columnName1={columnName1}
                                        columnName2={columnName2}
                                        columnName3={columnName3}
                                        isEcowise={isEcowise(
                                            item.filterOptions
                                        )}
                                        /* eslint-enable react/no-array-index-key */
                                    />
                                </CSSTransition>
                            ))}
                        </TransitionGroup>
                    </div>
                    <Resources resources={resources} />
                </div>
                <ItemPagination
                    totalPages={totalPages}
                    currentPage={currentPage}
                    changePage={changePage}
                />
            </div>
        </div>
    );
}

ListingItemsSection.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    listingItems: arrayOf(object).isRequired,
    itemWrapperModifier: string.isRequired,
    itemDirection: oneOf(['horizontal', 'vertical']).isRequired,
    itemType: string.isRequired,
    resources: arrayOf(object).isRequired,
    totalPages: number.isRequired,
    currentPage: number.isRequired,
    changePage: func.isRequired,
    resetFilters: func.isRequired,
    handleOpenModal: func.isRequired,
    viewMoreText: string.isRequired,
    meetUsText: string.isRequired,
    downloadText: string.isRequired,
    viewProductText: string.isRequired,
    noDataMessage: string.isRequired,
    noDataButtonText: string.isRequired,
    noDataButtonUrl: string.isRequired,
    noItemsText: string.isRequired,
    columnName1: string.isRequired,
    columnName2: string.isRequired,
    columnName3: string.isRequired
    /* eslint-enable react/no-typos */
};
